module.exports = __webpack_public_path__ + "img/photo-0057.21b87a13.jpg";